export default "__VITE_ASSET__BtV3Rvz4__"